import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Form, Button, Input, Select, InputNumber, Modal, Radio, Upload, message, Space, Row, Col } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { axiosHandleEvent, axiosTable } from '../../tool/axios'
import { formItemLayout, tailLayout, ngetBase64 } from '../../js/globalParam'
import { apiPrefix } from '../../js/config'

const { Option } = Select

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'

    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
        message.error('上传图片不能大于3MB!')
    }

    return isJpgOrPng && isLt3M
}

export default function HealthListAdd() {

    const [formInstance] = Form.useForm()
    const [response, setResponse] = useState<any[]>([])

    const [platformStatus, setPlatformStatus] = useState<any[]>([])
    const [childPregStatus, setChildPregStatus] = useState<any[]>([])

    const [statusValue, setStatusValue] = useState<any[]>([])
    const [pregStatus, setpregStatus] = useState<number>(0)

    const [previewImage, setPreviewImage] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)

    let { id }: { id: string } = useParams()

    useEffect(() => {
        setStatusValue([{ name: '高' }, { name: '中' }, { name: '低' }])

        axiosTable.get('/manage_center/preg_status/list', { params: { preg_status: '' } }).then((res: any) => {
            setPlatformStatus(res)

            formInstance.setFieldsValue({
                preg_status: res[0].preg_status
            });
        })

        if (id) {
            axiosTable.get("/manage_center/preg_status_remind/detail", { params: { id } }).then((res: any) => {
                res.pic_url = [{ id: '', response: { data: [res.pic_url] }, url: res.pic_url }]

                if (res.preg_status == 1) {
                    axiosTable.get('/manage_center/preg_status/list', { params: { preg_status: 1 } }).then((res: any) => {
                        setChildPregStatus(res)
                    })
                }

                setResponse(res)
                setpregStatus(res.preg_status)

                formInstance.setFieldsValue(res)
            })
        }
    }, [])

    const onChangeStatus = (e: any) => {
        if (!id) {
            formInstance.setFieldsValue({
                which_day: undefined
            });

            formInstance.setFieldsValue({
                preg_prob: undefined
            });
        }

        if (e.target.value == 1) {
            formInstance.setFieldsValue({
                platform_preg_status_id: undefined
            });

            axiosTable.get('/manage_center/preg_status/list', { params: { preg_status: e.target.value } }).then((res: any) => {
                setChildPregStatus(res)
            })
        }

        setpregStatus(e.target.value)
    }

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const onFinish = (values: any) => {
        if (values.which_day) {
            if (!(values.which_day > 0) || !/^[0-9]*[1-9][0-9]*$/.test(values.which_day)) {
                message.error('天数只能输入大于0的整数')
                return;
            }
        }

        for (let i in values) {
            if (!values[i]) {
                message.error('参数不能为空')
                return;
            }
        }

        let url: string = '';
        values.pic_url = values.pic_url[0].response.data[0]

        if (values.preg_status != 1) {
            values.platform_preg_status_id = platformStatus.reduce((acc, item) => {
                if (item.preg_status == values.preg_status) {
                    acc = item.id
                }

                return acc
            }, '')
        }

        if (id) {
            // 编辑
            let newObj: any = Object.assign(response, values)
            url = '/manage_center/preg_status_remind/update'
            axiosHandleEvent.post(url, { id, ...newObj }).then(res => { })

        } else {
            // 新增
            url = '/manage_center/preg_status_remind/add';
            axiosHandleEvent.post(url, { ...values }).then(res => { })
        }
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    let beiyunBox = (<div>
        <Form.Item label="备孕阶段" name='platform_preg_status_id' rules={[{ required: true, message: '必须选择备孕阶段' }, () => ({
            validator(_, value) {
                if (!/\s/.test(value)) {
                    return Promise.resolve();
                }
                return Promise.reject(new Error('不能输入空格'));
            },
        })]}>
            <Select style={{ width: 160 }} placeholder='请选择'>
                {
                    childPregStatus.map((item: object | any) => {
                        return <Option value={item.id} key={item.id}>{item.status_name}</Option>
                    })
                }
            </Select>
        </Form.Item>

        <Form.Item name="preg_prob" label="怀孕几率" rules={[{ required: true, message: '必须选择怀孕几率' }, () => ({
            validator(_, value) {
                if (!/\s/.test(value)) {
                    return Promise.resolve();
                }
                return Promise.reject(new Error('不能输入空格'));
            },
        })]}>
            <Select style={{ width: 160 }} placeholder='请选择'>
                {
                    [{ name: '高' }, { name: '中' }, { name: '低' }].map((item: object | any) => {
                        return <Option value={item.name} key={item.name}>{item.name}</Option>
                    })
                }
            </Select>
        </Form.Item>
    </div>)

    return <div className="common-level2-edit">
        <h2>{id ? '编辑' : '新增'}健康提醒</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_editor" onFinish={onFinish}>
                <Form.Item label="妈妈状态" name='preg_status' rules={[{ required: true, message: '必须选择妈妈状态' }]}>
                    <Radio.Group onChange={onChangeStatus}>
                        {
                            platformStatus.map((item: object | any) => {
                                return <Radio value={item.preg_status} key={item.id}>{item.status_name}</Radio>
                            })
                        }
                    </Radio.Group>
                </Form.Item>

                {pregStatus == 1 && beiyunBox}
                <Form.Item label="状态天数">
                    <span style={{ marginRight: 5 }}>第</span>

                    <Form.Item name="which_day" noStyle rules={[{ required: true, message: '必须填写状态天数' }]}>
                        <InputNumber placeholder='状态天数' />
                    </Form.Item>

                    <span style={{ marginLeft: 5 }}>天</span>
                </Form.Item>

                <Form.Item name="remind_desc_up" label="状态描述" rules={[{ required: true, message: '必须填写状态描述' }, () => ({
                    validator(_, value) {
                        if (!/\s/.test(value)) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('不能输入空格'));
                    },
                })]}>
                    <Input placeholder="请填写与状态阶段、状态配图相应的提示内容" />
                </Form.Item>

                <Form.Item name="remind_desc_down_title" label="健康提醒标题" rules={[{ required: true, message: '必须填写健康提醒标题' }, () => ({
                    validator(_, value) {
                        if (!/\s/.test(value)) {
                            return Promise.resolve();
                        }

                        return Promise.reject(new Error('不能输入空格'));
                    },
                })]}>
                    <Input placeholder="请填写提醒标题" />
                </Form.Item>

                <Form.Item
                    name="pic_url"
                    label="健康提醒图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    extra="（大小不超过2M）"
                    rules={[{ required: true, message: '必须上传健康提醒图片' }]}
                >
                    <Upload
                        maxCount={1}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item name="remind_desc_down_content" label="健康提醒内容"
                    rules={[{ required: true, message: '必须填写健康提醒内容' }, () => ({
                        validator(_, value) {
                            if (!/\s/.test(value)) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('不能输入空格'));
                        },
                    })]}>
                    <Input.TextArea placeholder="请填写提醒内容" />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal
            visible={visible}
            title='浏览图片'
            footer={null}
            onCancel={() => { setVisible(false) }}
        >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
    </div >
}